import * as styles from "./CardText.css";
import { WrapperDrawnBorder } from "../wrappers/WrapperDrawnBorder";
import { ComponentPropsWithRef } from "react";
import clsx from "clsx";

export type CardTextProps = {
  width?: "fit" | "full";
  padding?: "default" | "small";
} & styles.ContainerVariants &
  ComponentPropsWithRef<"div">;

export const CardText = ({
  theme = "neutral",
  width = "fit",
  padding = "default",
  children,
  className,
  ...props
}: CardTextProps) => {
  return (
    <WrapperDrawnBorder
      className={clsx(className, styles.card({ width: width }))}
    >
      <div className={styles.container({ theme: theme, width: width, padding: padding })} >
        {children}
      </div>
    </WrapperDrawnBorder>
  );
};
